module.exports = "<div id=\"google-map\" style=\"width:100%; height:100%;\"></div>\n\n"